import React, { Component } from 'react'
import {
  Image,
  Header,
  Button,
  Modal,
  Grid,
  Divider,
  Accordion,
  Table
} from 'semantic-ui-react'

class ProductQuickView extends Component {
  state = {
    index: 0,
    imageLen: this.props.product.images.length,
    toggleEdit: false,
    qty: 1
  }

  toggleEdit() {
    this.setState({
      toggleEdit: !this.state.toggleEdit
    })
  }

  handleChange(e, data) {
    let val = data.value
    if (val > data.max) {
      val = data.max
    }
    this.setState({
      qty: val
    })
  }

  nextImage() {
    const { index, imageLen } = this.state
    let nextIndex = index + 1
    if (nextIndex === imageLen) {
      nextIndex = 0
    }
    this.setState({
      index: nextIndex
    })
  }
  prevImage() {
    const { index, imageLen } = this.state
    let nextIndex = index - 1
    if (nextIndex < 0) {
      nextIndex = imageLen - 1
    }
    this.setState({
      index: nextIndex
    })
  }

  onSubmit() {
    this.props.addToCart(null, null, this.state.qty)
    this.setState({
      toggleEdit: false,
      qty: 1
    })
    this.props.toggleQuickView()
  }

  render() {
    const {
      product,
      visible,
      toggleQuickView,
      selectedSize,
      selectSize,
      sizeGuide
    } = this.props
    const { images, name, description, v_productVariants: variants } = product
    const { index } = this.state
    return (
      <Modal open={visible} onClose={toggleQuickView} size="large">
        <Modal.Content>
          <Grid>
            <Grid.Column
              computer={8}
              mobile={16}
              style={{ padding: 0 }}
              textAlign="center"
            >
              <Image
                src={`/storage/${images[index]}`}
                centered
                verticalAlign="middle"
                size="large"
              />
              <div className="quick-view-buttons">
                <Button
                  icon="chevron left"
                  onClick={this.prevImage.bind(this)}
                  basic
                  circular
                />
                <Button
                  icon="chevron right"
                  onClick={this.nextImage.bind(this)}
                  basic
                  circular
                  floated="right"
                />
              </div>
            </Grid.Column>
            <Grid.Column computer={8} mobile={16}>
              <Header as="h3">
                {name}
              </Header>
              {description}
              <br />
              {/* <Link to="/">View full product &rarr;</Link> */}
              <Divider />
              {variants.map(variant =>
                <Button
                  key={variant.id}
                  disabled={!(variant.virtualinstock > 0)}
                  color={selectedSize !== variant.id ? 'grey' : 'red'}
                  basic={selectedSize !== variant.id}
                  circular
                  size="tiny"
                  style={{
                    borderRadius: '50%',
                    height: '30px',
                    width: '30px',
                    textAlign: 'center',
                    padding: 0
                  }}
                  onClick={() => selectSize(variant.id)}
                >
                  {variant.size}
                </Button>
              )}
              <br />
              <br />
              <Button
                color="red"
                onClick={this.onSubmit.bind(this)}
                disabled={!selectedSize}
                content={selectedSize === null ? 'Select a Size' : 'Add to Bag'}
              />
              <Button
                basic
                color="grey"
                content="Close"
                onClick={toggleQuickView}
              />
              <Divider />
              <Accordion
                panels={[
                  {
                    title: 'Size Guide',
                    content: (
                      <Table
                        basic="very"
                        compact="very"
                        style={{ fontSize: '11px' }}
                      >
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell>Size</Table.HeaderCell>
                            <Table.HeaderCell>Chest (cm)</Table.HeaderCell>
                            <Table.HeaderCell>Arm (cm)</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body>
                          {sizeGuide.length > 0
                            ? sizeGuide.map(size => {
                              return (
                                <Table.Row key={size.id}>
                                  <Table.Cell>
                                    {size.size}
                                  </Table.Cell>
                                  <Table.Cell>
                                    {size.chest
                                      .map(val => val + 'cm')
                                      .join(' - ')}
                                  </Table.Cell>
                                  <Table.Cell>
                                    {size.arm
                                      .map(val => val + 'cm')
                                      .join(' - ')}
                                  </Table.Cell>
                                </Table.Row>
                              )
                            })
                            : null}
                        </Table.Body>
                      </Table>
                    )
                  }
                ]}
                styled
              />
            </Grid.Column>
          </Grid>
        </Modal.Content>
      </Modal>
    )
  }
}

export default ProductQuickView



// WEBPACK FOOTER //
// ./src/components/ProductQuickView.jsx